var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8328 13.8654C20.7844 13.8654 21.9773 13.222 22.6876 12.3642C23.331 11.5868 23.8001 10.5012 23.8001 9.4155C23.8001 9.26807 23.7867 9.12063 23.7599 9C22.701 9.04021 21.4277 9.71037 20.6638 10.6084C20.0606 11.292 19.5111 12.3642 19.5111 13.4633C19.5111 13.6241 19.5379 13.785 19.5513 13.8386C19.6183 13.852 19.7255 13.8654 19.8328 13.8654ZM16.4819 30.0833C17.7821 30.0833 18.3584 29.2121 19.9802 29.2121C21.6288 29.2121 21.9907 30.0565 23.4382 30.0565C24.859 30.0565 25.8106 28.743 26.7086 27.4563C27.7139 25.9819 28.1294 24.5344 28.1562 24.4674C28.0624 24.4406 25.3415 23.3281 25.3415 20.2051C25.3415 17.4977 27.486 16.278 27.6066 16.1841C26.1859 14.1469 24.028 14.0932 23.4382 14.0932C21.8432 14.0932 20.5431 15.0583 19.7255 15.0583C18.8409 15.0583 17.6748 14.1469 16.2943 14.1469C13.6672 14.1469 11 16.3182 11 20.4196C11 22.9662 11.9918 25.6603 13.2115 27.4027C14.257 28.877 15.1684 30.0833 16.4819 30.0833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleAbout);
export default __webpack_public_path__ + "static/media/apple-about.1a0911648a93b18dc1e214a773db13a4.svg";
export { ForwardRef as ReactComponent };